export const DESIGN_SYSTEM_MODAL_HEADER_TITLE_ID =
  "design_system_modal_header_title";
